/* gsap.registerPlugin(ScrollTrigger);

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollToPlugin);
import { ScrollToPlugin } from "gsap/all"; */

import homeAnim from "./home";
import projectsAnim from "./projects";

let homepage = document.querySelector("#home");
if (homepage !== null) {
  homeAnim.init();
  const modal = document.getElementById("project-modal");

  /* Modal animation */
  let tlmodal = gsap.timeline({ paused: true });

  tlmodal.to(modal, {
    duration: 0.3,
    left: 0,
    opacity: 1,
  });

  /* MODALE (delegated) */

  const topmenu = document.querySelector(".topmenu-container");

  // helper to populate and show the modal for a given project card
  function openProjectModal(card) {
    const postId = card.dataset.postId;
    const postTitle = card.querySelector(".project-title .title").textContent;

    // move modal to document.body so it's outside the scrollable container
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    document.getElementById("modal-project-title").textContent = postTitle;

    //fetch(`/wp-json/wp/v2/projets/${postId}?acf_format=standard`)
    // fetch(`https://taurine-preprod.fr/2foisplus//wp-json/wp/v2/projets/${postId}?acf_format=standard&_embed=1`)
    fetch(
      `https://2foisplus.fr/wp-json/wp/v2/projets/${postId}?acf_format=standard&_embed=1`,
    )
      .then((response) => response.json())
      .then((data) => {
        // data.acf should contain all ACF fields  if the REST response
        // doesn't include them, the plugin/endpoint may not be enabled or
        // the fields are empty. guard against that to avoid runtime errors.
        //console.log("REST response for project", postId, data);
        if (!data || typeof data.acf === "undefined") {
          console.warn("ACF fields missing for project", postId, data);
          return;
        }
        document.getElementById("modal-project-subtitle").innerHTML =
          data.acf.project_title || "";
        document.getElementById("modal-project-description").innerHTML =
          data.acf.project_description || "";
        document.getElementById("modal-project-plus").innerHTML =
          data.acf.project_description_2 || "";
        document.getElementById("modal-project-review-title").innerHTML =
          data.acf.project_review_title || "";
        document.getElementById("modal-project-review-content").innerHTML =
          data.acf.project_review_content || "";

        const swiper = new Swiper(".projectSwiper", {
          slidesPerView: 1,
          init: false,
          spaceBetween: 0,
          loop: true,
          keyboard: {
            enabled: true,
            onlyInViewport: false,
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });

        const swiperWrapper = document.querySelector(".swiper-wrapper");
        swiperWrapper.innerHTML = "";
        data.acf.list_photos.forEach((photoUrl) => {
          const slide = document.createElement("div");
          slide.className = "swiper-slide";
          slide.innerHTML = `<img src="${photoUrl}" alt="Photo du projet" style="width:100%; height:auto;">`;
          swiperWrapper.appendChild(slide);
        });

        swiper.init();

        // Récupérer les noms des catégories via _embedded
        let categoryNames = [];
        if (data._embedded && data._embedded["wp:term"]) {
          data._embedded["wp:term"].forEach((taxTerms) => {
            taxTerms.forEach((term) => {
              if (term.taxonomy === "categories") {
                categoryNames.push(term.name);
              }
            });
          });
        }

        // Afficher les noms dans un élément HTML
        const categoriesElement = document.getElementById(
          "modal-project-categories",
        );
        if (categoriesElement) {
          categoriesElement.innerHTML = `<span>${categoryNames.length > 0 ? categoryNames.join("</span> <span>") : ""}</span>`;
        }
      });

    topmenu.style.display = "none";
    modal.style.display = "block";
    document.body.style.overflow = "hidden";

    tlmodal.play();
  }

  // close button listener
  document.addEventListener("click", (e) => {
    if (e.target.matches(".close")) {
      tlmodal.reverse();
      modal.style.display = "none";
      topmenu.style.display = "block";
      document.body.style.overflow = "visible";

      document.getElementById("modal-project-subtitle").innerHTML = "";
      document.getElementById("modal-project-description").innerHTML = "";
      document.getElementById("modal-project-plus").innerHTML = "";
      document.getElementById("modal-project-review-title").innerHTML = "";
      document.getElementById("modal-project-review-content").innerHTML = "";
      const swiperWrapper = document.querySelector(".swiper-wrapper");
      swiperWrapper.innerHTML = "";
    }
  });

  // delegated click for project cards (works for dynamically added cards)
  document.addEventListener("click", (e) => {
    const card = e.target.closest(".project-card");
    if (card) {
      openProjectModal(card);
    }
  });
}

let projectsPage = document.querySelector("#projects");
if (projectsPage !== null) {
  projectsAnim.init();
}

let mentionsPage = document.querySelector("#mentions");
if (mentionsPage !== null) {
  // Scroll to top button
  const scrollToTopBtn = document.getElementById("scroll-to-top");
  if (scrollToTopBtn) {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 300) {
        scrollToTopBtn.classList.add("visible");
      } else {
        scrollToTopBtn.classList.remove("visible");
      }
    });

    scrollToTopBtn.addEventListener("click", () => {
      ScrollSmoother.get().scrollTo(0, true);
    });
  }
}

